import React from 'react';

import { currencyList } from '@dashboard/services/currency';

import Select from '../Select';

const CurrencySelector = ({ name, ...props }) => {
  const items = Object.keys(currencyList).map(key => currencyList[key].code);

  return (
    <Select name={name} {...props}>
      {items.map(item => (
        <option value={item} key={item}>
          {item.toUpperCase()}
        </option>
      ))}
    </Select>
  );
};

export default CurrencySelector;
